import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiUrlService } from '../@core/services/api-url.service';
import { RmmMfaStateService } from '../@core/services/rmm-mfa-state.service';

export const rmmMfaGuard: CanActivateFn = async (_route, state) => {
  const mfa = inject(RmmMfaStateService);
  const router = inject(Router);
  const http = inject(HttpClient);
  const api = inject(ApiUrlService);
  const gate = router.createUrlTree(['/rmm-verificar'], { queryParams: { returnTo: state.url.split('?')[0] } });
  if (!mfa.valid) return gate;
  try {
    await firstValueFrom(http.get(`${api.rmmApi}-mfa/access`, { headers: { 'X-RMM-MFA': mfa.token! } }));
    return mfa.valid ? true : gate;
  } catch {
    mfa.clear();
    return gate;
  }
};
